/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Btn } from 'components/buttons';
import { CircleCheck } from '@entrata/portals-common/lib/icons';
import { emptyCircle } from 'images';
import styled from '@emotion/styled';

const StyledBtn = styled(Btn)`
  background-color: white;
  text-align: start;
  color: ${({ theme }) => theme.text.dark};
  font-size: 13px;
  line-height: 16px;

  ${({ selected, theme }) =>
    selected &&
    `color: ${theme.secondary.base};
   background-color: ${theme.secondary.light};
   border: 1px solid ${theme.secondary.base};
   `}
`;
const StyledIdTheftAmount = styled('div')`
  padding-left: 230px;
  position: absolute;
  @media (max-width: 768px) {
    right: 18px;
  }
`;

const StyledBtn2 = styled(Btn)`
  background-color: white;
  text-align: start;
  color: ${({ theme }) => theme.text.dark};
  font-size: 13px;
  line-height: 16px;
  justify-content: flex-start !important;
  gap: 8px !important;
  border-radius: 8px !important;

  ${({ selected, theme }) =>
    selected &&
    `color: ${theme.secondary.base};
    background-color: ${theme.secondary.light};
    border: 1px solid ${theme.secondary.base};
   `}
`;

const StyledImg = styled('img')`
  height: 18px;
  width: 18px;
`;

const ToggleBtnV2 = ({ amount, Idname, isIdtheft, children, name, selected, ...rest }) =>
  isIdtheft ? (
    <StyledBtn2 {...rest} selected={selected} appearance='secondary' block>
      {selected ? <CircleCheck size={16} /> : <StyledImg src={emptyCircle} alt='emptyCircle' />}
      {name}
      <br />
      {Idname} Protection
      <StyledIdTheftAmount>{amount ? `$${parseFloat(amount.replace('$', '')).toFixed(2)}` : '$0'}</StyledIdTheftAmount>
    </StyledBtn2>
  ) : (
    <StyledBtn {...rest} selected={selected} appearance='secondary' block>
      {selected ? <CircleCheck size={16} /> : <StyledImg src={emptyCircle} alt='emptyCircle' />}
      &nbsp;{name}
    </StyledBtn>
  );

ToggleBtnV2.propTypes = {
  children: PropTypes.node.isRequired,
  selected: PropTypes.bool,
};

export default ToggleBtnV2;
